
// @ts-ignore
import * as moment from 'moment';

interface BioZymePermissionsData { 
    alerts_bom_item_no_pkg_price: boolean;
    alerts_comp_no_cost: boolean;
    alerts_cust_no_salesperson: boolean;
    alerts_discontinue: boolean;
    alerts_form_noaclbulkdensity: boolean;
    alerts_invalid_cust_class: boolean;
    alerts_inventory_nocert: boolean;
    alerts_item_upcoming_hazard_analysis: boolean;
    alerts_pkg_low_qty: boolean;
    alerts_pkg_no_bom: boolean;
    alerts_salesperson_no_acct: boolean;
    alerts_sop_hold: boolean;
    alerts_uofm_no_lb_conv: boolean;
    alerts_update_uofm: boolean;
    alerts_vendor_upcoming_reapproval: boolean;
    amafermdrying: boolean;
    amafermdrying_schedule: boolean;
    bagging: boolean;
    biozymebucks: boolean;
    brands: boolean;
    checklist_edit_audits: boolean;
    easton_scheduling: boolean;
    eastonscheduling_only: boolean;
    ekonek_dryer: boolean;
    facilities: boolean;
    facilities_easton: boolean;
    fermentation: boolean;
    forecasting: boolean;
    forecasting_write: boolean;
    freight: boolean;
    freight_write: boolean;
    inventory: boolean;
    inventory_aging: boolean;
    lab_easton_checklists: boolean;
    maintenance_checklists: boolean;
    maintenance_checklists_easton: boolean;
    media_mixing: boolean;
    mixing: boolean;
    mixing_write: boolean;
    mixing_supervisor: boolean;
    pricingordering: boolean;
    pricingordering_write: boolean;
    pt_bagging: boolean;
    small_pack_fulfillment: boolean;
    purchasing: boolean;
    purchasing_write: boolean;
    purchasing_itemcost: boolean;
    purchasing_production: boolean;
    quality_easton_checklists: boolean;
    quality_stockyards_checklists: boolean;
    quality_team: boolean;
    reports_gp: boolean;
    reports_pricelists: boolean;
    reports_orders: boolean;
    reports_supplychain: boolean;
    reports_manufacturing: boolean;
    reports_quality: boolean;
    reworks: boolean;
    salesorder_manager: boolean;
    salesordercreate_overridemin: boolean;
    salesorderedit_delete: boolean;
    salesorderedit_freightonly: boolean;
    sanitation: boolean;
    sanitation_easton: boolean;
    scheduling_manchange: boolean;
    seed_lab: boolean;
    shippingtime: boolean;
    supplychain: boolean;
    supplychain_write: boolean;
    supplychain_description: boolean;
    supplychain_files: boolean;
    supplychain_pricingdetail: boolean;
    supplychain_request: boolean;
    testing_lab: boolean;
    tracking: boolean;
    tracking_quick_complete: boolean;
    tracking_teamnotifications: boolean;
    vendors: boolean;
    vendors_viewallclasses: boolean;
    vendors_hidespending: boolean;
    vendors_request: boolean;
    verification_bagging: boolean;
    verification_fermentation: boolean;
    verification_final_product: boolean;
    verification_media_mixing: boolean;
    verification_small_pack_bag_check: boolean;
    vendor_requestedprice: boolean;
    vendor_requestedprice_vendor: boolean;
    formulabuilder: boolean;
}
const BioZymePermissionsData = {
    create: (initValues?: Partial<BioZymePermissionsData> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            alerts_bom_item_no_pkg_price: false,
            alerts_comp_no_cost: false,
            alerts_cust_no_salesperson: false,
            alerts_discontinue: false,
            alerts_form_noaclbulkdensity: false,
            alerts_invalid_cust_class: false,
            alerts_inventory_nocert: false,
            alerts_item_upcoming_hazard_analysis: false,
            alerts_pkg_low_qty: false,
            alerts_pkg_no_bom: false,
            alerts_salesperson_no_acct: false,
            alerts_sop_hold: false,
            alerts_uofm_no_lb_conv: false,
            alerts_update_uofm: false,
            alerts_vendor_upcoming_reapproval: false,
            amafermdrying: false,
            amafermdrying_schedule: false,
            bagging: false,
            biozymebucks: false,
            brands: false,
            checklist_edit_audits: false,
            easton_scheduling: false,
            eastonscheduling_only: false,
            ekonek_dryer: false,
            facilities: false,
            facilities_easton: false,
            fermentation: false,
            forecasting: false,
            forecasting_write: false,
            freight: false,
            freight_write: false,
            inventory: false,
            inventory_aging: false,
            lab_easton_checklists: false,
            maintenance_checklists: false,
            maintenance_checklists_easton: false,
            media_mixing: false,
            mixing: false,
            mixing_write: false,
            mixing_supervisor: false,
            pricingordering: false,
            pricingordering_write: false,
            pt_bagging: false,
            small_pack_fulfillment: false,
            purchasing: false,
            purchasing_write: false,
            purchasing_itemcost: false,
            purchasing_production: false,
            quality_easton_checklists: false,
            quality_stockyards_checklists: false,
            quality_team: false,
            reports_gp: false,
            reports_pricelists: false,
            reports_orders: false,
            reports_supplychain: false,
            reports_manufacturing: false,
            reports_quality: false,
            reworks: false,
            salesorder_manager: false,
            salesordercreate_overridemin: false,
            salesorderedit_delete: false,
            salesorderedit_freightonly: false,
            sanitation: false,
            sanitation_easton: false,
            scheduling_manchange: false,
            seed_lab: false,
            shippingtime: false,
            supplychain: false,
            supplychain_write: false,
            supplychain_description: false,
            supplychain_files: false,
            supplychain_pricingdetail: false,
            supplychain_request: false,
            testing_lab: false,
            tracking: false,
            tracking_quick_complete: false,
            tracking_teamnotifications: false,
            vendors: false,
            vendors_viewallclasses: false,
            vendors_hidespending: false,
            vendors_request: false,
            verification_bagging: false,
            verification_fermentation: false,
            verification_final_product: false,
            verification_media_mixing: false,
            verification_small_pack_bag_check: false,
            vendor_requestedprice: false,
            vendor_requestedprice_vendor: false,
            formulabuilder: false,
        },
        initValues);
    }
};

export default BioZymePermissionsData;
